import {RootState} from 'store'
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {openFailureModalAction} from 'features/modal/alertSlice'
import {
  EegSummaryReportType,
  EEGSummaryResponseWithClient,
  FetchIndividualSummaryReportRequest,
  getEegSummaryBrainFunctionMappingReportApi,
  getEegSummaryBrainFunctionReportApi,
  getEegSummaryFiveIndicatorsReportApi,
  ReportBrainFunctionConnect,
  ReportFiveIndicator,
} from 'api/analysisApi'

export const eegSummaryBrainFunctionMapping = createAsyncThunk(
  '/api/v1/getReportBrainFunctionMapping',
  async (
    payload: FetchIndividualSummaryReportRequest,
    {rejectWithValue, dispatch},
  ) => {
    try {
      const response = await getEegSummaryBrainFunctionMappingReportApi(payload)
      return response.list
    } catch (err) {
      await dispatch(openFailureModalAction(err.message))
      return rejectWithValue(err.message)
    }
  },
)

export const eegSummaryFiveIndicators = createAsyncThunk(
  '/api/v1/getReportEegSummary',
  async (payload: EegSummaryReportType, {rejectWithValue, dispatch}) => {
    try {
      const response = await getEegSummaryFiveIndicatorsReportApi(payload)
      return response.data
    } catch (err) {
      await dispatch(openFailureModalAction(err.message))
      return rejectWithValue(err.message)
    }
  },
)

export const eegSummaryBrainFunction = createAsyncThunk(
  '/api/v1/getReportBrainFunction',
  async (payload: EegSummaryReportType, {rejectWithValue, dispatch}) => {
    try {
      const response = await getEegSummaryBrainFunctionReportApi(payload)
      return response.data
    } catch (err) {
      await dispatch(openFailureModalAction(err.message))
      return rejectWithValue(err.message)
    }
  },
)

interface EegSummaryState {
  loading: boolean
  error: any
  items: ReportFiveIndicator | null
  itemsBrainFunction: ReportBrainFunctionConnect | null
  itemsBrainFunctionMapping: EEGSummaryResponseWithClient[]
}

const initialState: EegSummaryState = {
  loading: false,
  error: null,
  items: null,
  itemsBrainFunction: null,
  itemsBrainFunctionMapping: [],
}

const slice = createSlice({
  name: 'eegSummaryReportSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(eegSummaryFiveIndicators.pending, (state, action) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(eegSummaryFiveIndicators.fulfilled, (state, action) => {
      state.loading = false
      console.log(action.payload)
      state.items = action.payload
    })
    builder.addCase(eegSummaryFiveIndicators.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
    })

    builder.addCase(eegSummaryBrainFunction.pending, (state, action) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(eegSummaryBrainFunction.fulfilled, (state, action) => {
      state.loading = false

      state.itemsBrainFunction = action.payload
    })
    builder.addCase(eegSummaryBrainFunction.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
    })

    builder.addCase(eegSummaryBrainFunctionMapping.pending, (state, action) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(
      eegSummaryBrainFunctionMapping.fulfilled,
      (state, action) => {
        state.loading = false

        state.itemsBrainFunctionMapping = action.payload
      },
    )
    builder.addCase(
      eegSummaryBrainFunctionMapping.rejected,
      (state, action) => {
        state.loading = false
        state.error = action.payload
      },
    )
  },
})

export default slice.reducer

export const selectItems = (state: RootState) => state.eegSummaryReport.items
export const selectItemsBrainFunction = (state: RootState) =>
  state.eegSummaryReport.itemsBrainFunction
export const selectItemsBrainFunctionMapping = (state: RootState) =>
  state.eegSummaryReport.itemsBrainFunctionMapping
